export const dashHome = {
  index: {
    boxes: {
      reservas: "الحجوزات",
      checkins: "تسجيلات الوصول",
      ocupacion: "الإشغال",
      facturacion: "الإيرادات",
      ingresosTotal: "إجمالي الإيرادات",
      saldos: "الأرصدة المستحقة",
      solicitudes: "طلبات الذكاء الاصطناعي",
      facturas: "الفواتير المستحقة",
      acciones: "الإجراءات المعلّقة",
      salen: "المغادرون اليوم",
      llegadas: "عمليات الوصول القادمة",
      ingresosDesglose: "تفصيل الإيرادات",
    },
    editToolbar: {
      done: "تم",
      addBox: "إضافة مربّع",
      reset: "إعادة تعيين",
      hint: "اسحب للتحريك · اسحب من الزاوية لتغيير الحجم",
      allBoxesVisible: "جميع المربّعات ظاهرة.",
      removeTitle: "إزالة",
      showOnboarding: "إظهار إشعار الإعداد",
    },
  },
  arrivals: {
    viewAll: "عرض جميع عمليات الوصول",
  },
  todayLeaving: {
    title: "النزلاء المغادرون اليوم",
    subtitle: "عمليات تسجيل المغادرة المقرّرة لتاريخ اليوم.",
    empty: "لا يوجد نزلاء مغادرون اليوم.",
    loading: "جارٍ تحميل مغادرات اليوم…",
    balance: "الرصيد",
    balanceDueTitle: "الرصيد المستحق: {amount} {currency}",
    paid: "مدفوع",
    paidTitle: "حجز مدفوع",
    viewAll: "عرض جميع المغادرات",
  },
  mobileNotice: {
    sheetAriaLabel: "تنزيل تطبيق WACheckin",
    closeAriaLabel: "إغلاق",
    title: "استفد إلى أقصى حدّ من WACheckin",
    desc: "اللوحة مصمَّمة لـ<b>سطح المكتب</b>. من الهاتف تحصل على ملخّص؛ ولإدارة <b>جميع الميزات</b> بسهولة، افتحها على حاسوبك أو نزّل <b>تطبيقنا</b>.",
    appStorePrefix: "نزّله من",
    googlePlayPrefix: "متوفّر على",
    continueOnMobile: "المتابعة على الهاتف",
  },
};
